
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.223 0A2.23 2.23 0 000 2.22v10.56C0 14 1 15 2.223 15h15.555C19 15 20 14 20 12.777V2.223C20 1 19 0 17.777 0h-1.836l-1.62 2.535.954 4.277-2.455 2.69-.806 4.01-1.52-4.551 2.018-2.639-1.583-4.033L11.66 0h-.742zm.232.83h8.166l-.434 1.459 1.108 2.701-2.963 2.508L6.25 5.832 2.084 9.168v3.75h8.994l.418 1.25h-9.04c-1.12 0-1.62-.501-1.62-1.621V2.449c0-1.12.5-1.619 1.62-1.619zm13.787 0h1.307c1.12 0 1.619.5 1.619 1.62v10.097c0 1.12-.5 1.621-1.62 1.621h-4.952l.252-1.25h5.068V6.666l-2.447-2.201-.403-1.797zM3.75 2.082c-2.225.001-2.223 3.34.002 3.338 2.225 0 2.225-3.338 0-3.338z"}})])
          )
        }
      }
    